import styled, { css } from 'styled-components'

import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

import { Button } from 'builder/components/Button'
import {
  Cards,
  PromotionTopic,
} from 'builder/components/SubscriptionCancellationFormNew/common/types'
import Typography, { FontWeights } from 'builder/styles/typography'
import { getLineHeightRatio } from 'builder/components/SubscriptionCancellationFormNew/common/utils'
import usePromotionCardValues from 'builder/components/SubscriptionCancellationFormNew/hooks/usePromotionCardValues'

export const PromotionButton = styled(Button)<{
  topic: PromotionTopic
}>(({ topic }) => {
  const { getCardStyles } = usePromotionCardValues()
  const cardStyles = getCardStyles(topic)
  const phoneViewHeight = [Cards.FeatureOrProblem, Cards.OtherReasons].includes(topic as Cards)
    ? '36px'
    : '48px'
  const phoneViewFontSize = [Cards.FeatureOrProblem, Cards.OtherReasons].includes(topic as Cards)
    ? '16px'
    : '18px'
  const phoneViewLineHeight = [Cards.FeatureOrProblem, Cards.OtherReasons].includes(topic as Cards)
    ? getLineHeightRatio(20, 16)
    : getLineHeightRatio(22, 18)

  return css`
    ${Typography.ButtonM}
    ${FontWeights.DemiBold}
    display: flex;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    line-height: ${getLineHeightRatio(22, 18)};
    color: ${Colors.White};
    background-color: ${cardStyles.buttonColor};
    border-radius: 4px;
    height: 48px;
    width: fit-content;
    padding-left: 24px;
    padding-right: 24px;

    &:hover {
      background-color: ${cardStyles.buttonHoverColor};
    }

    ${Media.Tablet`
        width: 476px;
        padding-left: unset !important;
        padding-right: unset !important;
    `}

    ${Media.Phone`
        height: ${phoneViewHeight};
        font-size: ${phoneViewFontSize};
        line-height: ${phoneViewLineHeight};
        width: 295px;
        padding-left: unset !important;
        padding-right: unset !important;
    `}
  `
})
